export default __webpack_public_path__ + "img/25a913f96c148aa8a1d706e1c6b9d738.svg";